// Portal axios instance (VII-207).
//
// Routes hit `/portal/...` on the same origin. Bearer token is injected from
// localStorage on every request via an interceptor; 401 responses clear the
// session so the next render redirects to /portal/login.

import axios from 'axios';
import { clearPortalSession, getPortalBearer } from './auth';

const baseURL = '/api';

const portalApi = axios.create({ baseURL });

portalApi.interceptors.request.use((config) => {
  const bearer = getPortalBearer();
  if (bearer) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${bearer}`;
  }
  return config;
});

portalApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearPortalSession();
    }
    return Promise.reject(error);
  },
);

export default portalApi;
